<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre3">Erster Akt</h3>
<p class="stage">Moskau. Tschernavayastraße 99. Eine geräumige
Dachstube, durch Öllampen erhellt, die von der Decke herabhängen.
Mehrere maskierte Männer, schweigend und in einer gewissen
Entfernung voneinander. Ein Mann in scharlachroter Maske sitzt
schreibend an einem Tische. Eine Tür im Hintergrunde. Vor ihr ein
Mann in gelbem Gewand mit gezücktem Schwert. Es klopft. Maskierte
Männer, in Mäntel gehüllt, treten ein.</p>
<p class="calibre1"><span class="speaker">Losung</span>: <span class="teletype">Per
crucem ad lucem.</span></p>
<p class="calibre1"><span class="speaker">Antwort</span>: <span class="teletype">Per
sanguinem ad libertatem.</span></p>
<p class="calibre1">( <span class="regie">Eine Uhr schlägt. Die Verschwörer bilden
einen Halbkreis in der Mitte der Bühne.</span>)</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Wie lautet das Wort?</p>
<p class="calibre1"><span class="speaker">Erster Verschwörer</span>: Rabat.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Die Antwort?</p>
<p class="calibre1"><span class="speaker">Zweiter Verschwörer</span>: Kalit.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Welche Stunde zählen
wir?</p>
<p class="calibre1"><span class="speaker">Dritter Verschwörer</span>: Die Stunde des
Leidens.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Welchen Tag?</p>
<p class="calibre1"><span class="speaker">Vierter Verschwörer</span>: Den Tag der
Unterdrückung.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Welches Jahr?</p>
<p class="calibre1"><span class="speaker">Fünfter Verschwörer</span>: Das neunte
seit der französischen Revolution.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Wieviel sind wir an
Zahl?</p>
<p class="calibre1"><span class="speaker">Sechster Verschwörer</span>: Zehn, neun
und drei.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Der Nazarener hatte
nicht so viel und hat die Welt erobert. Was ist es, was wir
wollen?</p>
<p class="calibre1"><span class="speaker">Siebenter Verschwörer</span>: Freiheit
schaffen.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Unser Evangelium?</p>
<p class="calibre1"><span class="speaker">Achter Verschwörer</span>:
Vernichtung.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Unsre Pflicht?</p>
<p class="calibre1"><span class="speaker">Neunter Verschwörer</span>: Gehorsam.
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page15" title="divisi/a41b"></a></p>
<p class="calibre1"><span class="speaker">Präsident</span>: Brüder, die Fragen haben
gute Antwort gefunden. Nur Nihilisten sind in unserer Mitte. Wir
wollen uns gegenseitig ins Gesicht blicken. ( <span class="regie">Die Verschwörer demaskieren sich.</span>) Michael, leiste
den Eid!</p>
<p class="calibre1"><span class="speaker">Michael</span>: Wir schwören! zu morden,
was noch Natur in uns ist. Nicht Liebe zu geben, nicht Liebe zu
nehmen. Mitleid weder dir noch mir. Nicht Brautstand, nicht
Hochzeit, bis das Ende gekommen. Wir schwören, heimlich bei Nacht
zu meucheln, Gift ins Glas zu gießen, Vater gegen Sohn, Mann gegen
Weib zu hetzen. Wir schwören ohne Zagen, ohne Hoffnung, ohne Ende
zu leiden, zu vernichten, zu rächen.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Sind wir alle einig?</p>
<p class="calibre1"><span class="speaker">Die Verschwörer</span>: Wir sind's. (
<span class="regie">Sie zerstreuen sich in verschiedenen Richtungen
über die Bühne.</span>)</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Die Stunde ist vorüber,
Michael, und sie ist noch nicht da.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ich wollt', sie wäre hier.
Wir können ohne sie wenig anfangen.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Sie kann doch nicht gefaßt
worden sein, Präsident? Die Polizei ist ihr auf der Spur, ich weiß
es.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Du scheinst immer recht
viel von dem zu wissen, was bei der Moskauer Polizei vorgeht. Zu
viel für einen ehrlichen Verschwörer.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Wenn die Hunde sie
gefangen haben, soll die rote Fahne der Revolution auf allen
Straßen von den Barrikaden wehen, bis wir sie gefunden haben. Es
war auch Wahnsinn von ihr, auf den Ball des Großfürsten zu gehen.
Ich habe sie gewarnt, aber sie sagte, sie müsse den Zar und die
ganze Satansbrut einmal von Angesicht zu Angesicht sehn.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Auf dem Hofball? <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page16" title="divisi/a41b"></a></p>
<p class="calibre1"><span class="speaker">Michael</span>: Ich habe keine Angst. Sie
ist so schwer zu fangen wie eine Wölfin, und doppelt so gefährlich.
Dann ist sie auch gut verkleidet. Doch gibt's etwas Neues im
Schloß, Präsident? Was treibt der Bluthund jetzt, außer seinen
einzigen Sohn zu martern? Hat einer von euch den Prinzen gesehen?
Man hört sonderbare Geschichten von ihm. Es heißt, er liebt das
Volk, aber ein Königssohn hat das noch nie getan. Das läßt sich
nicht anerziehen.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Seit einem Jahr ist er
vom Ausland zurück, und seitdem hält ihn sein Vater im Schloß in
strengem Gewahrsam.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Eine prächtige Art, ihn
zum Tyrannen zu machen. Doch gibt's Neuigkeiten, frag' ich?</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Eine Konferenz soll
morgen um vier Uhr stattfinden. Der Gegenstand ist geheim, die
Späher können nicht dahinterkommen.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Wenn eine Konferenz in
einem Königsschlosse stattfindet, so handelt sich's gewiß um
irgendeine blutige Tat. In welchem Zimmer wird die Konferenz
abgehalten?</p>
<p class="calibre1"><span class="speaker">Präsident</span> ( <span class="regie">aus
einem Briefe lesend</span>): Im gelben Gobelinsaal, der nach der
Kaiserin Katharina benannt ist.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ich geb' nichts auf
schönklingende Namen. Ich möchte wissen, wo er liegt.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Ich kann dir's nicht
sagen, Michael. Ich kenne mich im Innern von Gefängnissen besser
aus als in Palästen.</p>
<p class="calibre1"><span class="speaker">Michael</span> ( <span class="regie">sich
plötzlich an Alexis wendend</span>): Wo liegt der Saal, Alexis?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Im ersten Stock, mit der
Aussicht in den Lichthof. Aber warum fragst du, Michael?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ah, nichts, nichts, mein
Junge. Ich interessiere mich nur lebhaft für das Leben und das Tun
des Zaren, und ich hab' gewußt, daß du mir genau Auskunft über
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page17" title="divisi/KaFa"></a> das Schloß
geben kannst. Natürlich kennt sich jeder verhungerte Mediziner in
Moskau in königlichen Schlössern aus. Das bringt wohl euer Beruf
mit sich, nicht wahr?</p>
<p class="calibre1"><span class="speaker">Alexis</span> ( <span class="regie">beiseite</span>): Sollte Michael Verdacht gegen mich haben?
Etwas Seltsames ist heute in seinem Wesen. Warum kommt sie nicht?
Die ganze Glut der Revolution scheint in graue Asche zu zerfallen,
wenn sie nicht da ist.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Hast du in letzter Zeit
viele Kranke in deinem Spital kuriert?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Einer liegt zu Tode
darnieder, den ich gerne heilen würde, doch ich vermag's nicht.</p>
<p class="calibre1"><span class="speaker">Michael</span>: So, und wer wäre das?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Rußland, unsere Mutter.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Die Heilung Rußlands muß
der Chirurg besorgen – dazu ist das Messer nötig. Ich halte nichts
von deiner Heilmethode.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Professor, wir haben die
Abzüge deines letzten Aufrufs gelesen. Er ist wirklich gut.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Worüber handelt er,
Professor?</p>
<p class="calibre1"><span class="speaker">Professor</span>: Das Thema, lieber
Bruder, lautet: »Der Mord als ein Mittel der politischen
Reform.«</p>
<p class="calibre1"><span class="speaker">Michael</span>: Bei Revolutionen geb' ich
wenig auf Feder und Tinte. Ein Dolch richtet mehr aus als hundert
Epigramme. Wir wollen aber doch die letzte Leistung dieses
Gelehrten lesen. Reicht sie mir. Ich will sie vorlesen.</p>
<p class="calibre1"><span class="speaker">Professor</span>: Bruder, du liest immer
über die Punkte weg. Laß es lieber Alexis vorlesen.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Jawohl, er hat eine so
geschmierte Zunge wie nur irgendein junger Aristokrat. Ich für
meine Person geb' nichts auf Punkte, wenn nur der Sinn richtig
ist.</p>
<p class="calibre1"><span class="speaker">Alexis</span> ( <span class="regie">lesend</span>): »Die Vergangenheit hat dem Tyrannen gehört,
er hat sie besudelt. Uns gehört die Zukunft, wir <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page18" title="a41b/KaFa"></a> wollen sie heiligen.« Wohlan,
wir wollen die Zukunft heiligen. Wenigstens <em class="calibre10">eine</em>
Revolution soll's geben, die nicht im Verbrechen gezeugt, nicht mit
Mord genährt ist.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Mit dem Schwert haben sie
zu uns gesprochen, mit dem Schwert wollen wir antworten! Du bist zu
zart für uns, Alexis. Hier sollten nur Männer sein, deren Hände von
Arbeit rauh oder rot vom Blute sind.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Ruhe, Michael, Ruhe! Er
hat das mutigste Herz von uns allen.</p>
<p class="calibre1">Michael ( <span class="regie">beiseite</span>): Heute nacht wird
er seinen Mut brauchen können. ( <span class="regie">Man hört
draußen das Schellengeklingel eines Schlittens.</span>)</p>
<p class="calibre1"><span class="speaker">Eine Stimme von außen</span>: <span class="teletype">Per crucem ad lucem</span>.</p>
<p class="calibre1"><span class="speaker">Antwort der Wache</span>: <span class="teletype">Per sanguinem ad libertatem</span>.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Wer ist's?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Gott schütze das Volk!</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Willkommen, Vera,
willkommen! Unser Herz war schwer, weil wir dich nicht sahen. Doch
nun ist mir's, als sei der Stern der Freiheit aufgegangen, um uns
in unsrer Nacht zu leuchten. Was bringst du Neues?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Nacht ist es auch, mein
Bruder! Nacht ohne Mond und Sterne! Rußland ist ins Herz getroffen!
Iwan, den man den Zaren nennt, zückt jetzt nach unserer Mutter
einen Dolch, der schärfer ist als irgendeiner, den die Tyrannei je
gegen das Leben des Volkes geschmiedet hat.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Was hat der Tyrann schon
wieder getan?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Das Standrecht wird morgen in
Rußland verkündet.</p>
<p class="calibre1"><span class="speaker">Alle</span>: Das Standrecht! Wir sind
verloren! Wir sind verloren!</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Das Standrecht!
Unmöglich!</p>
<p class="calibre1"><span class="speaker">Michael</span>: Narr, in Rußland ist alles
möglich, nur nicht Reformen. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page19" title="a41b/KaFa"></a></p>
<p class="calibre1"><span class="speaker">Vera</span>: Ja, das Standrecht! Das
letzte Recht, an das sich das Volk geklammert hat, wird ihm
genommen. Ohne verhört, ohne gerichtet, sogar ohne angeklagt zu
werden, sollen unsere Brüder aus ihren Häusern geschleppt, in den
Straßen wie Hunde erschossen, sollen sie verbannt werden, um im
Schnee zu sterben, im Kerker zu verschmachten, in den Bergwerken zu
faulen. Wißt ihr, was das Standrecht bedeutet? Es bedeutet die
Erdrosselung einer ganzen Nation. Auf den Straßen wird es Tag und
Nacht von Soldaten wimmeln; an jeder Türe wird ein Posten stehen.
Niemand darf sich auf die Straße wagen, wenn er nicht ein Spion
oder Verräter ist. Wenn wir uns in Höhlen verkriechen müssen, um
uns zu verbergen, wenn wir nur verstohlen zusammenkommen, mit
verhaltenem Atem sprechen dürfen: wie sollen wir Rußland dann noch
nützen?</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Leiden können wir
wenigstens.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Das haben wir mehr als genug
getan. Jetzt hat die Stunde der Zerstörung und der Rache
geschlagen.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Bis jetzt hat sich das
Volk alles bieten lassen.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Weil's ihm bisher an Verstand
gefehlt hat. Wir aber, die Nihilisten, haben ihm jetzt vom Baume
der Erkenntnis zu essen gegeben, und der Tag des stummen Leidens
ist für Rußland vorbei.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Das Standrecht, Vera! Eine
entsetzliche Nachricht, die du da bringst.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Es ist der Totenschein
der Freiheit Rußlands.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Oder die Sturmglocke der
Revolution.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ist es auch sicher
wahr?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Hier ist der Erlaß. Ich hab'
ihn heut nacht einem jungen Gecken auf dem Ball gestohlen, einem
der Sekretäre des Prinzen Paul, der ihn zum Abschreiben bekommen
hatte. Dadurch habe ich mich verspätet. ( <span class="regie">Vera
gibt den Erlaß Michael, der ihn liest.</span>) <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page20" title="a41b/KaFa"></a></p>
<p class="calibre1"><span class="speaker">Michael</span>: »Zur Sicherung des
öffentlichen Wohles – Standrecht. Im Auftrage des Zaren, des Vaters
seines Volkes.« Vater seines Volkes!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Ja! Ein Vater, dessen Name
nicht geheiligt ist, dessen Reich eine Republik werden, dessen
Schuld nicht vergeben werden soll, weil er uns unser täglich Brot
genommen hat. Sein ist nicht die Kraft und die Herrlichkeit, weder
jetzt noch in Ewigkeit.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Es muß sich bei der
Konferenz, die morgen zusammentritt, um das Standrecht handeln. Der
Erlaß ist bis jetzt noch nicht unterschrieben.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Das soll auch nicht
geschehen, solange ich noch meine Zunge habe, um zu
protestieren.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Und ich meine Hände zum
Dreinschlagen.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Das Standrecht! Du guter
Gott, wie leicht hat es ein König, sein Volk zu Tausenden
hinzumorden – wir aber können uns nicht von einem einzigen derer,
die Europas Kronen tragen, freimachen. Worin besteht denn die
erhabene Majestät dieser Männer, daß die Hand unsicher wird, der
Dolch versagt, der Schuß sein Ziel verfehlt? Sind es nicht Menschen
mit denselben Leidenschaften wie wir, die den gleichen Krankheiten
ausgesetzt, von gleichem Fleisch und Blut sind, wie wir? Was ließ
Olgiati erzittern, als es zum großen Augenblick im Leben dieses
Römers kam, was machte Guidos Nerven in jenem Augenblick versagen,
wo er von Stahl und Eisen hätte sein sollen? Die Pest, sage ich,
auf die Schwächlinge in Neapel, Berlin und Madrid! Ich dächte, wenn
ich einem Gekrönten gegenüberstünde, würde mein Auge klarer sehen,
mein Ziel mir deutlicher vorschweben, mein ganzer Körper Kraft und
Stärke finden wie nie zuvor! Bedenkt, was sich zwischen uns und die
Freiheit Europas drängt! Ein paar alte Männer, verrunzelte,
wackelnde, zittrige <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page21" title="a41b/adelheidis"></a> Greise, die ein Kind um einen Dukaten
erwürgen, ein Weib bei Nacht niedermachen könnte. Und das steht
zwischen uns und der Demokratie, zwischen uns und der Freiheit.
Aber jetzt, scheint mir, sind die Männer ausgestorben, und die
schwerfällige Erde hat das viele Gebären über – sonst würde kein
gekrönter Hund mehr leben und Gottes Luft verpesten.</p>
<p class="calibre1"><span class="speaker">Alle</span> ( <span class="regie">durcheinander</span>): Versuch's mit uns!</p>
<p class="calibre1"><span class="speaker">Michael</span>: Auch du, Vera, wirst eines
Tages die Probe zu bestehen haben.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Das gebe Gott! Hab' ich nicht
gemordet, was noch Natur in mir ist, und werd' ich meinen Schwur
nicht halten?</p>
<p class="calibre1"><span class="speaker">Michael</span> ( <span class="regie">zum
Präsidenten</span>): Das Standrecht, Präsident! Jetzt ist keine
Zeit mehr zu verlieren. Wir haben noch zwölf Stunden vor uns, ehe
der Kronrat zusammentritt. Zwölf Stunden! Man kann eine Dynastie in
kürzerer Zeit entthronen!</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Jawohl, und auch um
einen Kopf kürzer werden. ( <span class="regie">Michael und der
Präsident ziehen sich in eine Ecke zurück und sitzen flüsternd
beisammen. Vera hebt den Erlaß auf und liest ihn für sich. Alexis
beobachtet sie und eilt plötzlich auf sie zu.</span>)</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Vera!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Alexis, du hier? Törichter
Knabe, hab' ich dich nicht gebeten, fortzubleiben? Wir alle hier
sind bestimmt, vor unserer Zeit zu sterben, vom Schicksal dazu
ausersehen, das Gute, das wir tun, mit Foltern zu sühnen. Du aber,
mit deinem strahlenden Jünglingsgesicht, du bist zu jung, schon zu
sterben.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Niemand ist zu jung, für
sein Vaterland zu sterben!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Warum kommst du Nacht für
Nacht hierher?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Weil ich mein Volk liebe.
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page22" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">Vera</span>: Deine Kameraden müssen dich
aber doch vermissen? Gibt es keine Verräter unter ihnen? Du weißt,
wie viele Spione hier auf der Universität sind. Alexis, du mußt
fort. Du siehst, wie verzweifelt uns das Leid gemacht hat. Hier ist
nicht Platz für eine Natur wie deine. Du darfst nicht
wiederkommen.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Warum denkst du so gering
von mir? Warum soll ich leben, wenn meine Brüder leiden?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Du hast einmal von deiner
Mutter mit mir gesprochen. Du sagtest, daß du sie liebst. Denk an
<em class="calibre10">sie</em>!</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Ich habe jetzt keine Mutter
außer Rußland. Mein Leben gehört ihr – mag sie's behalten oder
verschenken. Doch heute bin ich hier, um dich zu sehen. Es heißt,
du gingst morgen nach Nowgorod.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Ich muß. Sie werden dort
verzagt, und ich möchte die Flamme der Revolution zu solcher Lohe
anfachen, daß die Augen aller Herrscher in Europa davon geblendet
werden sollen. Wenn das Standrecht verhängt wird, brauchen sie mich
dort doppelt. Die Tyrannei eines Menschen scheint kein Ende zu
finden – aber die Leiden eines ganzen Volkes sollen ihr Ende
finden.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Gott weiß es, ich bin auf
Eurer Seite. Doch du darfst nicht reisen. Die Polizei fahndet nach
dir in jedem Zug. Wenn man dich faßt, sollst du ohne Verhör ins
tiefste Verlies des Palastes geworfen werden. Ich weiß es –
gleichviel woher. Oh, denke daran, wie mit dir die Sonne aus
unserem Leben schwindet – wie das Volk seinen Führer, die Freiheit
ihre Priesterin verliert. – Vera, du darfst nicht gehen.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Wenn du es wünschest, will
ich bleiben. Ich möchte noch länger für die Freiheit, noch länger
für Rußland leben.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Wenn du fällst, dann ist
Rußland verloren – wenn du fällst, dann verläßt mich jede Hoffnung
– <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page23" title="a41b/adelheidis"></a>
jede … Vera, eine schreckliche Nachricht bringst du da – das
Standrecht – es ist zu furchtbar. Ich hab' es nicht gewußt – bei
meiner Seligkeit, ich hab' es nicht gewußt!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Wie hättest du es auch wissen
können? Dafür ist es ein viel zu schlau angelegtes Komplott. Der
gewaltige weiße Zar, dessen Hände rot sind vom Blute des Volkes,
das er gemordet hat, dessen Seele schwarz ist von Niedertracht, er
ist der abgefeimteste Verschwörer unter uns allen. Wie kann es in
Rußland zwei so verschiedene Herzen geben, wie deines und
seines!</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Vera, der Kaiser war nicht
immer so wie jetzt. Es gab eine Zeit, da hat er das Volk geliebt.
Der Satan – Gott verdamm' ihn! – Fürst Paul Maraloffski hat ihn so
weit gebracht. Morgen, ich schwör' es dir, will ich für das Volk
zum Zaren sprechen.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Du willst zum Zaren sprechen?
Toller Knabe, nur die zum Tode Verurteilten bekommen je den Zaren
zu sehen. Und dann – was gibt er auf eine Stimme, die um Gnade
fleht? Der Todesschrei eines Riesenvogels hat sein steinernes Herz
nicht bewegt.</p>
<p class="calibre1"><span class="speaker">Alexis</span> ( <span class="regie">für
sich</span>): Und dennoch will ich zu ihm sprechen. Man kann mich
höchstens töten.</p>
<p class="calibre1"><span class="speaker">Professor</span>: Hier sind die
Proklamationen, Vera. Glaubst du, daß sie ihren Zweck erfüllen?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Ich werde sie lesen. Wie
schön er ist! Er hat noch nie so vornehm ausgesehen wie heute
nacht. Gesegnet ist die Freiheit, für die ein solcher Mann
erglüht.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Nun, Präsident, womit seid
Ihr so beschäftigt?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Wir denken nur über die
beste Art nach, wie man Bären schießt. ( <span class="regie">Flüstert mit dem Präsidenten und führt ihn
beiseite.</span>)</p>
<p class="calibre1"><span class="speaker">Professor</span> ( <span class="regie">zu
Vera</span>): Und welche Antwort sollen wir unseren Brüdern in
Paris und Berlin auf ihre Briefe geben? <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page24" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">Vera</span> ( <span class="regie">nimmt
die Briefe mechanisch</span>): Hätte ich nicht geschworen, nicht
Liebe zu geben, nicht Liebe zu nehmen, ich glaube, ich hätte ihn
geliebt. Oh, ich bin wahnsinnig, bin selbst eine Verräterin – eine
Verräterin! Doch warum kam er auch zu uns mit einem frischen,
jungen Gesicht, seinem freiheitsentflammten Herzen, seiner reinen,
weißen Seele! Warum erzeugt er manchmal in mir den Wunsch, ihn zum
Herrn und König zu haben, in mir, die ich Republikanerin bin? Oh,
Närrin, dreimal Närrin! Verräterin an deinem Eide! Schwankender als
Wasser! Mach' ein Ende! Denk daran, was du bist – eine Nihilistin,
eine Nihilistin!</p>
<p class="calibre1"><span class="speaker">Präsident</span> ( <span class="regie">zu
Michael</span>): Man wird dich festnehmen, Michael.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ich glaube nicht. Ich will
die Uniform der kaiserlichen Garde anlegen, und der wachthabende
Oberst ist einer der unseren. Das Zimmer liegt im ersten Stock, du
erinnerst dich – ich kann also einen wohlgezielten Schuß
abgeben.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Soll ich unsern Brüdern
etwas davon sagen?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Kein Wort davon, kein
Wort! Ein Verräter ist unter uns.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Ist das die Proklamation?
Jawohl, sie wird ihren Zweck erfüllen. Schickt fünfhundert Nummern
nach Kiew, Odessa und Nowgorod, fünfhundert nach Warschau, und laßt
die doppelte Zahl in den südlichen Gouvernements verteilen. Die
schwerfälligen russischen Bauern kümmern sich allerdings wenig um
unsere Proklamation und noch weniger um unsere Leiden. Wenn der
Schlag geführt wird, muß es von der Stadt und nicht vom Lande aus
geschehen.</p>
<p class="calibre1"><span class="speaker">Michael</span>: So ist's – und mit dem
Schwert, nicht mit dem Federkiel.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Wo sind die Briefe aus
Polen?</p>
<p class="calibre1"><span class="speaker">Professor</span>: Hier! <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page25" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">Vera</span>: Unglückliches Polen! Die
Adler Rußlands haben dir am Herzen gezehrt. Wir dürfen unsere
Brüder dort nicht vergessen. –</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Ist das wahr, was du da
sagst, Michael?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Jawohl, ich verwette
meinen Kopf dafür!</p>
<p class="calibre1"><span class="speaker">Präsident</span>: So laßt die Türen
schließen. Alexis Iwantschiewitsch ist unsrer Brüderschaft als
Student der Medizin an der Universität Moskau beigetreten. Warum
hast du uns nichts von dem Blutplan erzählt, daß das Standrecht
verhängt werden soll?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Ich, Präsident?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ja, du! Du hast davon
gewußt – mehr als alle anderen. Waffen wie die werden nicht an
einem Tag geschmiedet. Warum hast du uns nichts davon gesagt? Noch
vor einer Woche wäre Zeit gewesen, Minen zu legen, Barrikaden zu
bauen, zum mindesten einen Streich für die Freiheit zu führen. Doch
jetzt ist die Stunde verpaßt. Es ist zu spät, zu spät! Warum hast
du vor uns ein Geheimnis daraus gemacht, frage ich?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Bei der Hand der Freiheit,
du verleumdest mich, Michael, mein Bruder. Ich wußte nichts von
diesem scheußlichen Erlaß. Bei meinem Seelenheil, Brüder, ich wußte
nichts davon. Wie hätte ich auch sollen?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Weil du ein Verräter bist!
Wohin bist du von hier nach unserer letzten nächtlichen Versammlung
gegangen?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: In meine Wohnung,
Michael.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Lügner! Ich war dir auf
den Fersen. Du gingst von hier um ein Uhr nachts fort. In einen
weiten Mantel eingehüllt, hast du über den Fluß gesetzt, eine Meile
unterhalb der zweiten Brücke, und hast dem Bootsmann ein Goldstück
gegeben, du, der arme Student der Medizin! Zweimal bist du
zurückgegangen und hast dich unter <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page26" title="a41b/adelheidis"></a> einem Torbogen versteckt – so lange,
daß ich fast drauf und dran war, dich niederzumachen, wenn ich
nicht so sehr aufs Jagen erpicht wäre. Du dachtest wohl, jede
Verfolgung unmöglich gemacht zu haben, nicht wahr? Schwachkopf! Ich
bin ein Bluthund, der seine Spur nie verliert. Ich bin dir von
Straße zu Straße gefolgt. Endlich bemerkte ich, wie du eilig über
den Sankt-Isaaks-Platz gingst, der Wache das geheime Losungswort
zurauntest und durch eine Nebentüre, zu der du einen Schlüssel
hattest, in den Palast tratst.</p>
<p class="calibre1"><span class="speaker">Die Verschwörer</span>: In den Palast!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Alexis!</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ich wartete weiter. All
die öden Stunden der langen russischen Nacht hab' ich gewartet.
Töten wollt' ich dich, wenn du mit dem Judaslohn in der Hand
herauskämst. Doch du bist nicht mehr herausgekommen. Du hast den
Palast nicht mehr verlassen. Ich sah die Sonne durch den braunen
Nebel blutigrot über der düstern Stadt aufgehen – sah einen neuen
Tag der Unterdrückung für Rußland kommen. Doch du bist nicht mehr
herausgekommen. Du verbringst also ganze Nächte im Schloß? Du
kennst das Losungswort für die Wache! Du hast einen Schlüssel zu
einer Nebentür? Pfui, ein Spion bist du – ein Spion! Ich hab' dir
nie getraut, dir mit deinen weichen, weißen Händen, deinem
Lockenhaar, deinem Mädchengesicht. Du hast nicht eine Spur
erlittener Qualen an dir; du kannst es nicht mit dem Volk halten.
Ein Spion bist du – ein Spion – ein Verräter!</p>
<p class="calibre1"><span class="speaker">Alle</span> ( <span class="regie">durcheinander</span>): Nieder mit ihm! Nieder mit ihm! (
<span class="regie">Ziehen ihre Dolche.</span>)</p>
<p class="calibre1"><span class="speaker">Vera</span> ( <span class="regie">sich vor
Alexis werfend</span>): Zurück, Michael! Zurück mit euch allen!
Wagt nicht, Hand an ihn zu legen! Er ist der Beste von uns allen.
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page27" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">Alle</span>: Nieder mit ihm! Nieder mit
ihm! Er ist ein Spion!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Wagt ihn anzurühren, und ich
lasse euch alle miteinander im Stich.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Vera, hast du nicht
gehört, was Michael von ihm berichtet hat? Er hat die ganze Nacht
im Zarenschloß zugebracht. Er kennt das Losungswort – hat einen
Geheimschlüssel. Was kann er anderes sein als ein Spion?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Pah! Ich glaube Michael
nicht. Es ist nur Lüge – nur Lüge! Alexis, sag', daß es gelogen
ist!</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Es ist wahr. Michael hat
nur erzählt, was er wirklich gesehen hat. Ich bin nachts ins
Zarenschloß gegangen. Michael hat die Wahrheit gesagt.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Zurück, sag' ich, zurück!
Alexis, mir liegt nichts daran. Ich traue dir. Du könntest uns
nicht verraten – nicht das Volk für Geld verkaufen. Du meinst es
ehrlich und treu! Sag', daß du kein Spion bist!</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Spion? Du weißt, daß ich's
nicht bin. Ich gehöre euch, meine Brüder, bis zum Tode!</p>
<p class="calibre1"><span class="speaker">Michael</span>: Du meinst bis zu deinem
Tod.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Vera, du weißt, daß ich
treu bin.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Ich weiß es.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Warum bist du
hergekommen, Verräter?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Weil ich das Volk
liebe.</p>
<p class="calibre1"><span class="speaker">Michael</span>: Dann kannst du auch ein
Märtyrer fürs Volk werden!</p>
<p class="calibre1"><span class="speaker">Vera</span>: Erst mußt du mich töten,
Michael, ehe du ihn auch nur mit dem Finger berührst.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Michael, wir dürfen Vera
nicht verlieren. Es ist nun einmal ihre Laune, dem Burschen das
Leben zu retten. Wir können ihn hier über Nacht behalten. Vorher
hat er uns ja noch nicht verraten. ( <span class="regie">Auf dem
Gang Schritte von Soldaten, es wird an die Tür geklopft.</span>)
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page28" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">Eine Stimme</span>: Öffnet, im Namen des
Kaisers!</p>
<p class="calibre1"><span class="speaker">Michael</span>: Er <em class="calibre10">hat</em> uns
verraten! Das ist dein Werk, Spion!</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Ruhig, Michael, ruhig!
Wir haben keine Zeit, uns den Hals abzuschneiden, wenn es gilt,
unseren Kopf zu retten.</p>
<p class="calibre1"><span class="speaker">Die Stimme</span>: Öffnet im Namen des
Kaisers!</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Brüder, nehmt alle die
Larven vor. Michael, öffne die Tür. Es bleibt uns keine Wahl. (
<span class="regie">General Kotemkin und Soldaten treten
ein.</span>)</p>
<p class="calibre1"><span class="speaker">General</span>: Alle guten Bürger haben
eine Stunde vor Mitternacht in ihrem Haus zu sein, und nicht mehr
als fünf Leute haben das Recht, zusammenzukommen. Kennt ihr die
Bekanntmachung nicht, Kerle?</p>
<p class="calibre1"><span class="speaker">Michael</span>: Ja. Ihr habt doch jede
anständige Mauer in Moskau damit vollgeschmiert.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Ruhe, Michael, Ruhe. Nein,
Herr, wir kennen die Bekanntmachung nicht. Wir sind eine wandernde
Schauspielertruppe – auf dem Wege von Samara nach Moskau, um Seine
kaiserliche Hoheit, den Zaren, zu belustigen.</p>
<p class="calibre1"><span class="speaker">General</span>: Aber ich habe lärmende
Stimmen gehört, bevor ich hereinkam. Was hatte das zu bedeuten?</p>
<p class="calibre1"><span class="speaker">Vera</span>: Wir haben ein neues
Trauerspiel geprobt.</p>
<p class="calibre1"><span class="speaker">General</span>: Eure Antworten klingen mir
zu ehrlich, als daß sie wahr wären. Laßt sehen, wer ihr seid. Herab
mit diesen Gauklermasken. Beim heiligen Nikolaus, mein nettes Kind,
wenn dein Gesicht so hübsch ist, wie deine Gestalt, so mußt du ein
Leckerbissen sein. Also los, Schätzchen, dein Gesicht will ich zu
allererst sehen.</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Mein Gott! Wenn er
sieht, daß es Vera ist, sind wir alle verloren!</p>
<p class="calibre1"><span class="speaker">General</span>: Keine Ziererei, mein Kind!
Marsch, sag' ich, oder ich gebe meiner Wache Auftrag, dir die
Arbeit zu erleichtern. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page29" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">Alexis</span>: Halt, sag' ich, General
Kotemkin!</p>
<p class="calibre1"><span class="speaker">General</span>: Wer bist du, Kerl, daß du
mit so losem Maul zu deinem Vorgesetzten sprichst? ( <span class="regie">Alexis nimmt die Maske ab.</span>) Seine kaiserliche
Hoheit, der Zarewitsch!</p>
<p class="calibre1"><span class="speaker">Alle</span>: Der Zarewitsch! Nun ist es
aus!</p>
<p class="calibre1"><span class="speaker">Präsident</span>: Er wird uns den Soldaten
ausliefern.</p>
<p class="calibre1"><span class="speaker">Michael</span> ( <span class="regie">zu
Vera</span>): Warum hast du mich ihn nicht töten lassen? Vorwärts –
jetzt heißt's auf Leben und Tod kämpfen.</p>
<p class="calibre1"><span class="speaker">Vera</span>: Bleib ruhig! Er wird uns
nicht verraten.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Eine meiner Launen,
General! Sie wissen, wie mich mein Vater von der Welt absperrt und
mich im Schloß gefangen hält. Ich müßte mich wirklich zu Tode
langweilen, wenn ich nicht mitunter bei Nacht verkleidet
entschlüpfen und in der Stadt ein kleines, romantisches Abenteuer
erleben könnte. Ich hab' die guten Leute hier vor ein paar Stunden
getroffen.</p>
<p class="calibre1"><span class="speaker">General</span>: Ganz recht, Hoheit, aber
–</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Ich versichere Ihnen, es
sind ausgezeichnete Schauspieler. Wären Sie zehn Minuten früher
gekommen, so hätten Sie eine höchst interessante Szene mitansehen
können.</p>
<p class="calibre1"><span class="speaker">General</span>: Sind es wirklich
Schauspieler, mein Prinz?</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Jawohl, und sogar sehr
ehrgeizige Schauspieler. Sie wollen nur vor Majestäten spielen.</p>
<p class="calibre1"><span class="speaker">General</span>: Meiner Treu, Hoheit, ich
hatte schon gehofft, einen guten Fang gemacht und Nihilisten
erwischt zu haben.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Nihilisten in Moskau,
General! Wo Sie Polizeichef sind? Ausgeschlossen!</p>
<p class="calibre1"><span class="speaker">General</span>: Das sage ich auch immer zu
Ihrem kaiserlichen Herrn Vater. Ich habe aber heute im Staatsrat
gehört, daß das Weibsbild Vera Saburoff, die Rädelsführerin, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page30" title="a41b/adelheidis"></a> hier in der
Stadt gesehen worden ist. Das Gesicht des Kaisers wurde weiß wie
der Schnee draußen. Ich glaube, ich habe nie einen Menschen so
erschrecken sehen.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Wohl ein gefährliches Weib,
die Vera Saburoff?</p>
<p class="calibre1"><span class="speaker">General</span>: Das gefährlichste in ganz
Europa.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Haben Sie sie schon jemals
gesehen, General?</p>
<p class="calibre1"><span class="speaker">General</span>: Das schon – vor fünf
Jahren, als ich noch ein simpler Oberst war. Ich erinnere mich
noch, Hoheit, wie sie ein gewöhnliches Schankmädchen war. Wenn ich
damals gewußt hätte, was aus ihr werden wird, ich hätte sie im
Straßengraben zu Tode peitschen lassen. Sie ist kein Weibsbild –
ein Teufelsbraten ist sie. In den letzten anderthalb Jahren bin ich
hinter ihr her, und einmal hab' ich sie in der Umgebung von Odessa
gesehen.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Wie kam es, daß sie Ihnen
entwischt ist, General?</p>
<p class="calibre1"><span class="speaker">General</span>: Ich war allein, und sie
schoß eines meiner Pferde gerade in dem Augenblicke nieder, als ich
sie fassen wollte. Wenn ich sie wieder erwische, will ich meine
Karten nicht aus der Hand geben. Der Kaiser hat zwanzigtausend
Rubel auf ihren Kopf gesetzt.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Hoffentlich fallen sie
Ihnen zu, General! Aber indessen erschrecken Sie die guten Leute
hier zu Tode und stören das Spiel. Gute Nacht, General.</p>
<p class="calibre1"><span class="speaker">General</span>: Zu dienen, Hoheit – ich
möchte aber doch ihre Gesichter sehen.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Nein, General. Das müssen
Sie nicht verlangen. Sie wissen doch, wie es fahrendem Volk gegen
den Strich geht, sich anstarren zu lassen.</p>
<p class="calibre1"><span class="speaker">General</span>: Zu dienen, Hoheit. Doch
–</p>
<p class="calibre1"><span class="speaker">Alexis</span> ( <span class="regie">von
oben herab</span>): General, es sind meine Freunde. Das genügt.
Übrigens, General, kein Wort von dem kleinen Abenteuer hier – Sie
verstehen mich. Ich verlasse mich auf Sie. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page31" title="a41b/adelheidis"></a></p>
<p class="calibre1"><span class="speaker">General</span>: Ich werde daran denken,
mein Prinz. Aber werden wir Sie nicht noch im Schloß sehen? Der
Hofball ist beinahe vorüber, und man erwartet Sie.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Ich werde kommen – aber
allein. Nicht vergessen – kein Wort von meinen Schauspielern!</p>
<p class="calibre1"><span class="speaker">General</span>: Und von Ihrer hübschen
Zigeunerin – wie, mein Prinz? Ihre hübsche Zigeunerin! Wirklich,
ich möchte sie sehen, bevor ich gehe. Man sieht so schöne Augen
durch die Maske. Also, gute Nacht, Hoheit, gute Nacht.</p>
<p class="calibre1"><span class="speaker">Alexis</span>: Gute Nacht, General. (
<span class="regie">General und die Soldaten ab.</span>)</p>
<p class="calibre1"><span class="speaker">Vera</span> ( <span class="regie">ihre
Maske herunterreißend</span>): Gerettet! Durch dich gerettet!</p>
<p class="calibre1"><span class="speaker">Alexis</span> ( <span class="regie">ihre
Hand ergreifend</span>): Brüder, wollt ihr mir jetzt vertrauen?
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page32" title="a41b/adelheidis"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?63ed4f78